import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // use import {NgIdleModule} from '@ng-idle/core'; if not using keepalive
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PortalModule } from './shell/portal.module';
import { SVG_ASSET_MAP, PNG_ASSET_MAP } from './asset-maps';
import { NgFileDropDirective } from 'src/vendor/ng2-uploader/directives/ng-file-drop';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { ConfigurationService } from './shared/configuration/configuration.service';
import { LoginComponent } from './login/login.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthHttpInterceptorService } from './shared/http/interceptors/auth-http-interceptor.service';
import { RouteReuseStrategy } from '@angular/router';
import { TabRouteReuseStrategyService } from './shared/routing/tab-route-reuse-strategy.service';
import { AuthModule } from './shared/auth/auth.module';
import { ConfigurationModule } from './shared/configuration/configuration.module';
import { CloudMaintenanceHttpInterceptorService } from './shared/http/interceptors/cloud-maintenance-http-interceptor.service';
import { OutOfLicenseHttpInterceptorService } from './shared/http/interceptors/out-of-license-http-interceptor.service';
import { LoginCallbackComponent } from './shell/login-callback/login-callback.component';
import { SessionTimeoutComponent } from './shell/session-timeout/session-timeout.component';
import { ConcurrentAccessInterceptorService } from './shared/http/interceptors/concurrent-access-interceptor.service';

const appInitializerFn = (configurationService: ConfigurationService) => {
  return () => {
    return configurationService.loadCurrentConfiguration();
  };
};

@NgModule({
  declarations: [
    AppComponent,
    NgFileDropDirective,
    LoginComponent,
    LoginCallbackComponent,
    SessionTimeoutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    GridModule,
    BrowserAnimationsModule,
    NgIdleKeepaliveModule.forRoot(), // use NgIdleModule.forRoot() if not using keepalive
    TreeViewModule,
    PortalModule,
    AuthModule,
    ConfigurationModule,
    HttpClientModule
  ],
  providers: [
    {
      provide: 'SVG_MAP',
      useValue: SVG_ASSET_MAP
    }, {
      provide: 'PNG_MAP',
      useValue: PNG_ASSET_MAP
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [ConfigurationService]
    },
    { provide: RouteReuseStrategy, useClass: TabRouteReuseStrategyService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CloudMaintenanceHttpInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OutOfLicenseHttpInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConcurrentAccessInterceptorService,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
